export default [
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('@/views/extensions/acl/AccessControl.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/views/Callback.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/silent-renew',
    name: 'silent-renew',
    component: () => import('@/views/SilentRenew.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/presentation',
    name: 'presentation',
    component: () => import('@/views/pages/Presentation.vue'),
    meta: {
      layout: 'full',
    },
  },
]
